import { ECurrencyType } from './constants'
import { ICurrencyDto } from './getValidPairsAndCurrencies'

const getPairCoinTypes = ({
    availableCurrencies,
    fromCode = null,
    toCode = null,
}: {
    availableCurrencies: ICurrencyDto[]
    fromCode: string
    toCode: string
}): {
    fromCurrencyType: ECurrencyType
    toCurrencyType: ECurrencyType
} => {
    let fromCurrencyType
    let toCurrencyType

    for (const currency of availableCurrencies) {
        if ((fromCurrencyType || !fromCode) && (toCurrencyType || !toCode)) break

        if (fromCode && !fromCurrencyType && currency.code === fromCode) {
            fromCurrencyType = currency.isCrypto ? ECurrencyType.CRYPTO : ECurrencyType.FIAT
        }

        if (toCode && !toCurrencyType && currency.code === toCode) {
            toCurrencyType = currency.isCrypto ? ECurrencyType.CRYPTO : ECurrencyType.FIAT
        }
    }

    return {
        fromCurrencyType,
        toCurrencyType,
    }
}

export { getPairCoinTypes }
